import { post } from '@rails/request.js';
import UppyFrench from '@uppy/locales/lib/fr_FR';
import Uppy from '@uppy/core'
import Dashboard from '@uppy/dashboard'
import AwsS3 from '@uppy/aws-s3'

function setupFileUpload(fileInput) {
  const formGroup = fileInput.parentNode,
    hiddenInput = document.querySelector(`#${formGroup.id} .upload-data`),
    dashboardContainer = document.querySelector(`#${formGroup.id} .upload-dashboard`);

  // remove our file input in favour of Uppy's
  formGroup.removeChild(fileInput)

  let allowedFileTypes;
  switch (formGroup.id) {
    case 'container-upload-file':
    case 'container-upload-new-file':
      allowedFileTypes = ["video/*"];
      break;
    case 'container-upload-vignette':
      allowedFileTypes = ["image/*"];
      break;
    case 'container-upload-subtitle':
      allowedFileTypes = [".itt", ".srt", ".vtt"];
      break;
  }

  const uppy = new Uppy({
    autoProceed: true,
    locale: UppyFrench,
    restrictions: {
      maxNumberOfFiles: 1,
      allowedFileTypes
    }
  })

  uppy.use(AwsS3, {
    endpoint: '/',
    shouldUseMultipart: true,
  })

  uppy.use(Dashboard, {
    inline: true,
    target: dashboardContainer,
    proudlyDisplayPoweredByUppy: false,
    width: 350,
    height: 180,
  })

  uppy.on('upload-success', (file, response) => {
    // construct uploaded file data in the format that Shrine expects
    let matches = response.uploadURL.match(/\/cache\/([^\?]+)/);
    if (!matches) {
      matches = response.uploadURL.match(/\/dev-cache\/([^\?]+)/);
    }

    const uploadedFileData = {
      id: matches[1], // extract key without prefix
      storage: 'cache',
      metadata: {
        size: file.size,
        filename: file.name,
        mime_type: file.type,
      }
    }

    // set hidden field value to the uploaded file data so that it's submitted
    // with the form as the attachment
    hiddenInput.value = JSON.stringify(uploadedFileData)
  })

  uppy.on('upload-error', (file, response) => {
    uppy.removeFile(file.id)
  })

  const form = formGroup.closest('form')

  form.addEventListener('submit', function (event) {
    if (formGroup.id == 'container-upload-file') {
      const file = hiddenInput.value

      if (!file && !confirm('Vous n\'avez pas téléchargé de vidéo. Veuillez en télécharger une pour continuer.\n\nSi ceci n\'est pas intentionnel, veuillez cliquer sur \'Annuler\', laisser cette page ouverte et contacter le service TI. Sinon, cliquer sur \'OK\'.')) {
        event.preventDefault();
        event.stopPropagation();
        return false;
      }
    }

    return true;
  })
}

function setupMultiFileUpload(dashboardContainer) {
  const uppy = new Uppy({
    autoProceed: true,
    locale: UppyFrench,
    restrictions: {
      allowedFileTypes: ["video/*"]
    }
  })

  uppy.use(AwsS3, {
    endpoint: '/',
    shouldUseMultipart: true,
  })

  uppy.use(Dashboard, {
    inline: true,
    target: dashboardContainer,
    proudlyDisplayPoweredByUppy: false,
    theme: 'dark',
    showLinkToFileUploadResult: false,
    replaceTargetContent: true,
  })

  uppy.on('upload-success', async (file, response) => {
    // construct uploaded file data in the format that Shrine expects
    let matches = response.uploadURL.match(/\/cache\/([^\?]+)/);
    if (!matches) {
      matches = response.uploadURL.match(/\/dev-cache\/([^\?]+)/);
    }

    const uploadedFileData = {
      id: matches[1], // extract key without prefix
      storage: 'cache',
      metadata: {
        size: file.size,
        filename: file.name,
        mime_type: file.type,
      }
    }

    const body = {
      video: {
        title: file.name.replace(/\.(mp4|mov|m4v)/, ""),
        file: JSON.stringify(uploadedFileData)
      }
    };

    try {
      const response = await post("/videos.json", { body: JSON.stringify(body) });

      if (!response.ok) {
        throw "";
      }
    } catch (e) {
      alert(`Une erreur réseau a eu lieu lors du téléchargement de la vidéo ${file.name}.\n\nVeuillez réessayer.`);
    }
  })
}


export { setupFileUpload, setupMultiFileUpload }
